import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import { styled } from '@mui/material/styles';

const FloatingIconWrapper = styled('div')(({ theme, visible }) => ({
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: visible ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100px',
  height: '100px',
  borderRadius: '50%',
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[4],
  zIndex: 1000,
  animation: 'fade-in-out 2s ease-in-out',
}));

const keyframes = `
  @keyframes fade-in-out {
    0% { opacity: 0; transform: scale(0.5); }
    20% { opacity: 0.8; transform: scale(1); }
    70% { opacity: 0.8; transform: scale(1); }
    100% { opacity: 0; transform: scale(0.5); }
  }
`;

const FloatingIcon = ({ visible, correct }) => {
  return (
    <div>
      <style>{keyframes}</style>
      <FloatingIconWrapper visible={visible}>
        {correct ? <CheckIcon style={{ fontSize: 60, color: 'green' }} /> : <CancelIcon style={{ fontSize: 60, color: 'red' }} />}
      </FloatingIconWrapper>
    </div>
  );
};

export default FloatingIcon;